<!-- ============================================================== -->
<!-- Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->
<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">Profile Page</h4>
        </div>

    </div>
</div>
<!-- ============================================================== -->
<!-- End Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->
<!-- ============================================================== -->
<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 10px;">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <!-- Row -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-4 col-xlg-3 col-md-5">
            <div class="card">
                <div class="card-body">
                    <div style="margin-left: 90px">
                        <img src="{{myurl+'Misc/Images/profilePhotos/'+profileObj._id}}" class="rounded-circle"
                            width="150">
                      

                    </div>
                    <div  style="text-align: center;margin-right: 50px;">
                        <h4 class="card-title m-t-10" style="margin-left: 40px;">{{profileObj.firstName | titlecase}}
                            {{profileObj.lastName | titlecase}}</h4>
                        <h6 class="card-subtitle"
                            style="margin-left:45px;font-weight: 600;color: #000000;font-size: 14px;">
                            {{profileObj.role_name | titlecase}}</h6>
                    </div>
                </div>
                <div>
                    <hr>
                </div>
                <div class="card-body">
                    <h4>Email address </h4>
                    <h6 class="title">{{profileObj.emailId}}</h6>
                    <h4>Phone</h4>
                    <h6 class="title">{{profileObj.mobileNumber}}</h6>
                    <a  routerLink="/mainview/changePassword">Change Password</a>
                    <!-- <small class="text-muted p-t-30 db">Address</small>
                        <h6>71 Pilgrim Avenue Chevy Chase, MD 20815</h6> -->
                </div>
            </div>
        </div>
        <!-- Column -->
        <!-- Column -->
        <div class="col-lg-8 col-md-7">
            <div class="card">
                <!-- Tabs -->

                <!-- Tabs -->
                <div class="tab-content" id="pills-tabContent">


                    <div class="tab-pane fade active show" id="previous-month" role="tabpanel"
                        aria-labelledby="pills-setting-tab">
                        <div class="card-body">
                            <form #profileForm="ngForm" novalidate>
                                <div class="row" style="padding:13px;">
                                    <div class="col-md-6">

                                        <div class="form-group" >
                                            <label class="col-md-6">First Name</label>
                                            <input type="text" required class="form-control form-control-line" #firstName="ngModel"
                                            pattern="^[^\d\W]+( [^\d\W]+)*$" minlength="3" maxlength="30" onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"   [(ngModel)]="profileObj.firstName" name="firstname">
                                            <span style="font-size: small" class="text-danger"
                                            [hidden]="!firstName.errors.required"
                                            *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                            This Field is Required</span>
                                        <span class="text-danger" [hidden]="!firstName.errors?.pattern" *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                            First Name Should Be Only Alphabets</span>
                                            <span class="text-danger" [hidden]="!firstName.errors?.minlength || firstName.errors.pattern" *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">First
                                            Name Should Be Min 3 Characters</span>
                                      
                                        </div>
                                    </div>
                                    <div class="col-md-6">

                                        <div class="form-group">
                                            <label class="col-md-6">Last Name</label>
                                            <input type="text" required class="form-control form-control-line" pattern="^[^\d\W]+( [^\d\W]+)*$" minlength="3" maxlength="30"
                                            onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)  || event.charCode==32"

                                                [(ngModel)]="profileObj.lastName" name="lastname">
                                                <span style="font-size: small" class="text-danger"
                                                [hidden]="!firstName.errors.required"
                                                *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                                This Field is Required</span>
                                            <span class="text-danger" [hidden]="!firstName.errors?.pattern" *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">
                                                First Name Should Be Only Alphabets</span>
                                                <span class="text-danger" [hidden]="!firstName.errors?.minlength || firstName.errors.pattern" *ngIf="firstName.errors && (firstName.touched || firstName.dirty)">First
                                                Name Should Be Min 3 Characters</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">

                                    <div class="form-group">
                                        <label for="example-email" class="col-md-12">Email</label>
                                        <input type="email" readonly required class="form-control form-control-line"
                                            [(ngModel)]="profileObj.emailId" name="example-email" id="example-email">
                                    </div>
                                </div>
                                <div class="col-md-12">

                                    <div class="form-group">
                                        <label class="col-md-12">Phone No</label>
                                        <input type="text" required readonly [(ngModel)]="profileObj.mobileNumber"
                                            name="mobilenumber" class="form-control form-control-line">
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <h5 class="card-title m-t-20">Profile
                                        Photo</h5>
                                  
    
                                    <div class="btn btn-info waves-effect waves-light">
                                        <input type="file"  id="container" accept="image/gif, image/jpeg, image/png"
                                         (change)="fileChangeEvent($event)"   #profilePhoto="ngModel" name="profilePhoto"
                                            [(ngModel)]="profileObj.profilePhoto" class="upload"> </div>
                                    <span class="text-danger" [hidden]="!profilePhoto.errors.required"
                                        *ngIf="profilePhoto.errors && (profilePhoto.touched || profilePhoto.dirty)">*This
                                        Field is required
                                    </span>
                                </div>
                                <img width="45.25em" height="46.25em"   [src]="pic" height="150" width="200px" style="margin: 3px;"> <br/>

                                <div class="form-group" style="margin-top: 15px;">
                                    <div class="col-sm-12">
                                        <button class="btn btn-success" [disabled]="!profileForm.valid"
                                            (click)="updateProfile()">Update Profile</button>&nbsp;&nbsp;
                                            <a class="btn btn-dark" href="#/mainview/dashboard" data-dismiss="modal">Cancel</a>
    
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- Row -->
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<!-- End Container fluid  -->
<!-- ============================================================== -->
<!-- ============================================================== -->

<!-- ============================================================== -->